import React from "react";
import { RaisedButton, TextField } from "material-ui";
import { Link } from "react-router";
import Radium from "radium";

import TextSmsIcon from "material-ui/svg-icons/communication/textsms";

import LinkLike from "./link-like.jsx";
import PhoneField from "./phone-field.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../../actions/PersonActions";
import PersonStore from "../../stores/PersonStore";

@connectToStores
class SmsTicketsWidgetSundance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sms_tickets_enabled: undefined,
      phone_number: ""
    };

    this._enable = this._enable.bind(this);
    this._disable = this._disable.bind(this);
  }

  static contextTypes = {
    tenant: React.PropTypes.object,
    muiTheme: React.PropTypes.object
  };

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  componentDidMount() {
    this.setState({
      sms_tickets_enabled: this.props.details.sms_tickets_enabled,
      phone_number: this.props.details.phone_number
    });
  }

  _enable() {
    this.setState({ sms_tickets_enabled: true });
    PersonActions.edit({
      sms_tickets_enabled: true,
      phone_number: this.state.phone_number
    });
  }

  _disable() {
    this.setState({ sms_tickets_enabled: false });
    PersonActions.edit({
      sms_tickets_enabled: false
    });
  }

  getStyles() {
    return {
      container: {
        display: "flex",
        alignItems: "center",
        paddingTop: "1em",
        paddingBottom: "1em",
        minHeight: 96,
        boxSizing: "border-box"
      },
      icon: {
        width: 60,
        height: 60,
        marginRight: "1em"
      }
    };
  }

  render() {
    let styles = this.getStyles();

    // SMS tickets disabled
    if (!this.context.tenant.sms_tickets_enabled) {
      return null;
    }

    const isLarge = this.props.large;

    return (
      <div style={styles.container}>
        <div>
          {this.state.sms_tickets_enabled ? (
            <div>
              <div>
                Your tickets will be sent via text message to{" "}
                {this.state.phone_number} an hour before showtime.
              </div>
              <div style={{ fontSize: "0.8em" }}>
                <LinkLike
                  style={{ color: "rgb(33,33,33)" }}
                  onClick={this._disable}
                >
                  Stop receiving tickets by text / change phone number
                </LinkLike>
              </div>
            </div>
          ) : (
            <div>
              <div style={{ margin: "-5px 0", display: isLarge ? "flex" : "block", fontWeight: "bold" }}>
                <div style={{ paddingRight: 20, paddingTop: 17 }}>Mobile Phone:</div>
                <PhoneField
                  autoFocus
                  hintText="(123) 456-7890"
                  value={this.state.phone_number}
                  style={{
                    width: 128,
                    marginRight: "1em",
                    marginLeft: isLarge ? "0.5em" : 0,
                    border: "2px solid #eee",
                    padding: "0px 10px 0px 10px"
                  }}
                  underlineShow={false}
                  onChange={e =>
                    this.setState({ phone_number: e.target.value })
                  }
                />
                <div style={{ 
                  paddingLeft: isLarge ? 20 : 0, 
                  paddingTop: 10,  
                  paddingBottom: isLarge ? 0 : 20
                }}>
                  <RaisedButton
                    primary={true}
                    disabled={
                      !this.state.phone_number ||
                      this.state.phone_number.replace(/[^\d]/g, "").length === 0
                    }
                    label="Receive tickets by text"
                    onClick={this._enable}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default SmsTicketsWidgetSundance;



// WEBPACK FOOTER //
// ./src/app/components/partials/sms-tickets-widget-sundance.jsx